import styled from 'styled-components';
import logoSecretaria from '../../imgs/brasao_ceara.svg';
import logoMobile from '../../imgs/brasao_sspds.png';

export const Profile = styled.div`
  display: flex;
  align-items: center;
  border-left: 2px solid #fff;
  height: 50px;
  text-align: center;

  #userName {
    display: block;
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    padding-left: 20px;

    @media screen and (max-width: 400px) {
      display: none;
    }
  }

  .avatar {
    @media screen and (max-width: 400px) {
      border-radius: 20%;
      right: 10px;
      margin-left: 30px;
    }
  }

  div {
    text-align: right;
    margin-right: 10px;

    a {
      display: block;
      margin-top: 2px;
      font-size: 12px;
      color: #999;
    }
  }
`;

export const Container = styled.div`
  .labelEco {
    @media (max-width: 50em) {
      display: none !important;
    }
  }

  .logosEco svg {
    min-width: 26px;
    min-height: 27px;
  }

  .labelEcoMobile {
    @media (min-width: 50em) {
      display: none !important;
    }
  }

  .logosEco {
    @media (max-width: 50em) {
      margin: 0 auto !important;
    }
  }

  .governo {
    display: flex !important;
  }

  .profile {
    display: flex;
    position: absolute;
    right: 20px;
    top: 40%;

    align-items: center;
    justify-content: flex-end;
    @media (max-width: 50em) {
      // display: none;
    }
  }

  .menu_browser {
    @media (max-width: 50em) {
      display: none;
    }
  }

  .menu_mobile {
    /* @media (min-width: 50em) {
      display: none;
    } */
  }

  .searchable {
    @media (max-width: 72em) {
      display: none;
    }
  }

  body {
    background: #e9e9e9;
    font-family: 'Raleway', sans-serif;
    margin: 0px;
    padding: 0px;
  }

  .standard_layout .content_contain {
    overflow: hidden;
    background: #e9e9e9;
  }

  .mark {
    margin-right: 1.25em;
  }

  @media (min-width: 50em) {
    .mark {
      display: none !important;
    }
  }

  .nav_contain {
    display: block;
    padding: 0.75em 0;
    text-align: center;
    ul {
      @media (min-width: 72em) {
        display: -webkit-box;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        padding: 0;
        margin: 0;
      }

      li {
        display: block;
        padding: 0.75em 0;
        text-align: center;
        a {
          position: relative;
          display: block;
          color: #090910;
          text-decoration: none;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        }
        @media (min-width: 72em) {
          position: relative;
          margin-right: 8.5%;
          border-bottom: none;
        }
      }
    }

    @media (min-width: 72em) {
      max-height: 100vh;
      overflow: visible;
      opacity: 1;
      padding: 0;
      -webkit-transform: none;
      transform: none;
      margin-right: 300px;
    }
  }

  /* HEADER */

  header {
    position: relative;
    z-index: 1000;
    -webkit-transition: padding 0.3s ease;
    transition: padding 0.3s;
    width: 100%;

    display: flex;
    align-items: center;
    background: linear-gradient(to left, #56bfc9, #24a637 65%);

    .appName {
      font-size: 40px;
      color: white;

      @media screen and (max-width: 1000px) {
        font-size: 32px;
      }
    }
    .separator {
      border: rgb(203, 213, 225) 1px solid;
      margin: 0px 8px 0px 8px;
      box-shadow: 2px 2px 0px rgb(0 128 0 /11%);
      height: 50px;

      @media screen and (max-width: 1000px) {
        display: none;
      }
    }

    .imgBottomHeader {
      background: white;
    }

    .sspdsName {
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: 200px;
      color: white;
      margin: 4px 0px 0px 4px;

      .longName {
        font-size: 16px;
      }

      .governName {
        font-size: 12px;
      }

      @media screen and (max-width: 1000px) {
        display: none;
      }
    }

    .greenBar {
      width: 100%;

      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 50px 15px 50px 15px;
      position: relative;
      z-index: 1001;

      @media screen and (max-width: 1000px) {
        justify-content: start;
      }
    }

    .imgTopHeader {
      position: absolute;
      left: 0px;
      bottom: 0px;
      width: calc(30rem + 0.4vw);

      @media screen and (max-width: 800px) {
        display: none;
      }
    }

    .contain {
      /* padding: 0 1em;
      max-width: 80em; */
      overflow-x: hidden;
      width: 100%;
    }

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      display: block;
      top: 0;
      left: 0;
      width: 100%;
      height: 85px;
      box-shadow: 0 10px 15px -8px rgba(9, 9, 16, 0);
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
      -webkit-transition: box-shadow 0.6s ease;
      transition: box-shadow 0.6s ease;
    }

    .logoImg {
      content: url(${logoSecretaria});
      max-width: 400px;
      height: 74px;
    }

    @media (max-width: 620px) {
      .logoImg {
        display: none;
        content: url(${logoMobile});
        max-width: 45px;
        max-height: 61px;
      }
    }

    @media (max-width: 375px) {
      .ant-avatar-lg {
        width: 4em;
        height: 3em;
      }
    }
    .header_content_menu {
      display: -webkit-box;
      display: flex;
      -webkit-box-align: none;
      align-items: center;
      background-color: #fff;
      padding: 15px;
      justify-content: space-between;
      height: 30px;
    }

    @media (max-width: 424px) {
      .baseOndas {
        display: none;
      }
      .header_content_menu {
        justify-content: center;
      }
    }

    .page_contain {
      max-width: 100em;
      margin: 0 auto;
      padding: 0 5.5%;
      margin-top: -150;
    }

    .search_box .input_group {
      padding: 0;
      width: 100%;
      -webkit-transition: width 0.5s ease;
      transition: width 0.5s ease;
      margin-right: 30;
    }
  }
  .baseOndas {
    position: absolute;
    padding-top: 15px;
  }

  .baseOndas img {
    height: 14px;
  }
`;

